export const questionGroupKeyRegex = /^q\d+$/i;
export const questionKeyRegex = /^q\d+(?:\.|$)/i;
export const optionKeyRegex = /^q\d+\.opt_\d+\.text$/i;
